import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13991 15592"
    {...props}
  >
    <path
      d="m10728 13629-720-1893H3877l-720 1932c-281 755-520 1264-720 1527-197 264-523 397-976 397-383 0-724-140-1018-421-296-281-443-601-443-956 0-207 35-421 102-639 70-221 183-523 341-916l3855-9791c113-281 243-618 397-1011 155-397 320-724 495-983 176-260 404-471 689-633C6163 81 6514 0 6932 0c429 0 783 81 1068 242 284 162 512 369 688 622s323 527 442 818c120 292 274 681 457 1166l3940 9731c309 741 464 1278 464 1615 0 348-144 671-436 963-291 291-646 435-1057 435-239 0-446-42-618-130-168-84-312-200-432-347-116-148-239-376-372-678-137-306-249-576-348-808zM4681 9440h4506L6915 3224 4681 9440z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
